import { createElement as e } from "react";
import { IconAlertTriangle as t, IconCircleCheck as n, IconCircleOff as r } from "@tabler/icons-react";
import { showNotification as i } from "@mantine/notifications";
import { normalizeErrorString as a } from "@medplum/core";
// ../core/dist/es/events.mjs
var o = class {
	onError(e) {
		this.errorHandler = e;
	}
	onPublish(e) {
		this.publishHandler = e;
	}
	subscribe(e, t) {
		return this.listeners.has(e) || this.listeners.set(e, /* @__PURE__ */ new Set()), this.listeners.get(e).add(t), () => {
			this.unsubscribe(e, t);
		};
	}
	unsubscribe(e, t) {
		let n = this.listeners.get(e);
		n && (n.delete(t), n.size === 0 && this.listeners.delete(e));
	}
	publish(e, t) {
		let n = this.listeners.get(e);
		if (n && n.forEach((n) => {
			try {
				n(t);
			} catch (n) {
				if (console.error(`Error in event listener for ${e}:`, n), this.errorHandler) try {
					this.errorHandler(n, e, t);
				} catch {}
			}
		}), this.publishHandler) try {
			this.publishHandler(e, t);
		} catch {}
	}
	removeAllListeners(e) {
		e ? this.listeners.delete(e) : this.listeners.clear();
	}
	listenerCount(e) {
		return this.listeners.get(e)?.size || 0;
	}
	constructor() {
		this.listeners = /* @__PURE__ */ new Map();
	}
}, s = Symbol.for("@benchmark/core/globalEventEmitter"), c = globalThis, l = c[s] ?? (c[s] = new o()), u = {
	AppointmentCreated: "appointment.created",
	AppointmentUpdated: "appointment.updated",
	CarePlanActivated: "care-plan.activated",
	CarePlanCancelled: "care-plan.cancelled",
	CarePlanCompleted: "care-plan.completed",
	CarePlanCreated: "care-plan.created",
	CarePlanHeld: "care-plan.held",
	CarePlanPaused: "care-plan.paused",
	CarePlanResumed: "care-plan.resumed",
	CarePlanUpdated: "care-plan.updated",
	CarePlanActivityCompleted: "care-plan.activity.completed",
	CareTimeCreated: "care-time.created",
	CareTimeDeleted: "care-time.deleted",
	CareTimeUpdated: "care-time.updated",
	CoCMBillingSummaryCreated: "cocm-billing-summary.created",
	CoCMBillingSummaryUpdated: "cocm-billing-summary.updated",
	CoCMBillingPacketSubmitted: "cocm-billing-packet.submitted",
	CoCMBillingPacketReopened: "cocm-billing-packet.reopened",
	CareTeamCreated: "care-team.created",
	CareTeamUpdated: "care-team.updated",
	ClinicalImpressionCreated: "clinical-impression.created",
	ClinicalImpressionDeleted: "clinical-impression.deleted",
	ClinicalImpressionUpdated: "clinical-impression.updated",
	CommunicationCreated: "communication.created",
	ConditionCreated: "condition.created",
	ConditionUpdated: "condition.updated",
	CommunicationUpdated: "communication.updated",
	CoverageCreated: "coverage.created",
	CoverageUpdated: "coverage.updated",
	EncounterCreated: "encounter.created",
	EncounterUpdated: "encounter.updated",
	FlagCreated: "flag.created",
	FlagUpdated: "flag.updated",
	GoalCreated: "goal.created",
	GoalUpdated: "goal.updated",
	GoalProgressRecorded: "goal.progress.recorded",
	GoalClosed: "goal.closed",
	HealthcareServiceCreated: "healthcare-service.created",
	HealthcareServiceUpdated: "healthcare-service.updated",
	AvailabilityUpdateLogged: "availability-update.logged",
	LibraryCreated: "library.created",
	LibraryUpdated: "library.updated",
	LibraryReviewed: "library.reviewed",
	LibraryEndorsed: "library.endorsed",
	LibraryRetired: "library.retired",
	LocationCreated: "location.created",
	OrganizationCreated: "organization.created",
	ObservationCreated: "observation.created",
	ObservationUpdated: "observation.updated",
	PatientCreated: "patient.created",
	PatientPaused: "patient.paused",
	PatientUnpaused: "patient.unpaused",
	PatientUpdated: "patient.updated",
	PractitionerCreated: "practitioner.created",
	PractitionerRoleCreated: "practitioner-role.created",
	PractitionerRoleUpdated: "practitioner-role.updated",
	PractitionerUpdated: "practitioner.updated",
	QuestionnaireCreated: "questionnaire.created",
	QuestionnaireResponseCreated: "questionnaire-response.created",
	QuestionnaireResponseUpdated: "questionnaire-response.updated",
	QuestionnaireUpdated: "questionnaire.updated",
	RelatedPersonCreated: "related-person.created",
	RelatedPersonUpdated: "related-person.updated",
	ServiceRequestCreated: "service-request.created",
	ServiceRequestUpdated: "service-request.updated",
	TaskCompleted: "task.completed",
	TaskCreated: "task.created",
	TaskUpdated: "task.updated",
	NotificationTaskCreated: "notification-task.created",
	NotificationTaskUpdated: "notification-task.updated",
	UserErrorShown: "user-error.shown"
}, d = (t, n) => {
	l.publish(u.UserErrorShown, {
		source: "notification",
		severity: "minor",
		error: t,
		title: n?.title
	}), i({
		color: "red",
		icon: e(r),
		title: n?.title || "Error",
		message: a(t),
		autoClose: n?.autoClose ?? 1e4
	});
}, f = (t) => {
	i({
		color: "green",
		icon: e(n),
		title: "Success",
		message: t,
		autoClose: 5e3
	});
}, p = (n, r) => {
	i({
		color: "yellow",
		icon: e(t),
		title: "Warning",
		message: n,
		autoClose: r?.autoClose ?? 8e3
	});
};
export { f as n, p as r, d as t };

//# sourceMappingURL=notification-cuDCu4_f.js.map